import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";

const calculationMethodsReducer = (state = initialState.currentOffer.calculationMethods, action) => {
  switch (action.type) {
    case actionTypes.LOAD_CALCULATION_METHODS_SUCCESS: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: true
        }
      };
    }
    default:
      return state;
  }
};

export default calculationMethodsReducer;
